/**
 * TanStack Query hooks for `dpf`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	dpfQueryKeys,
	type CreateDpfBody,
	type ListDpfResponse,
	type DpfRow,
} from "./api";

export function useDpfList(): UseQueryResult<ListDpfResponse, Error> {
	return useQuery({
		queryKey: dpfQueryKeys.list(),
		queryFn: list,
	});
}

export function useDpfCreate(): UseMutationResult<DpfRow, Error, CreateDpfBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: dpfQueryKeys.all });
		},
	});
}

export function useDpfDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: dpfQueryKeys.all });
		},
	});
}
